<template>
	<div id="appbox">
		<div class="top_heard" >
				<div class="top_box" v-if="screenWidth>785">
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<div class="top_gatebox">
						<div class="manage_switch" v-if="screenWidth>785">
							<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
							  <el-option
							    v-for="item in manageoptions"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								>
							  </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="top_search_box" v-if="screenWidth>785" >
						<div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								
								>
							  </el-option>
							</el-select>
							<!-- <i class="el-icon-search"></i> -->
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
						</div>
						  
					</div>
					<div class="top_right">
						<div class="top_Mobiletype" @click="goregister()">
							账号注册/绑定
						</div>
						<div class=""  v-if="token" >
							欢迎访问!
						</div>
						<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
							登出
						</div>
					</div>
				</div>
				<div class="top_tab_box">
					<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
						<template #left>
							<div class="vannav_title" style="color: #217495;font-size: 16px;" >
								资讯详情
							</div>
						</template>
						<template #title>
							<div class="vannav_title" style="width: 180px;padding: 20px;">
									<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
							</div>
						</template>
					  <template #right>
						  <van-icon name="ellipsis"  size="20"    />
					  </template>
					</van-nav-bar>
					<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
						<van-picker
						  title=""
						  show-toolbar
						  :columns="vannavlist"
						  confirm-button-text="进入"
						  @confirm="vanlinkgo"
						  @cancel="vannavmenushow"
						  @change="onChange"
						/>
					</van-popup>
					<div class="toptabnav" v-if="screenWidth>785">
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#1b9d57"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
								<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
				</div>
			</div>
		<!-- <div class="swim_box" v-if="screenWidth>785" >
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="newsdata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			
			<div class="newslist_box" :style="screenWidth>785?'':'width:100%;    flex-direction: column;'">
				<div class="newslist" :style="screenWidth>785?'':'width:100%; margin:0px;'">
					<div class="video_box" v-if="newsdata.vdo != ''">
						<video :src="newsdata.vdo" controls type="video/mp4"></video>
					</div>
					<div class="newsdatas" :style="screenWidth>785?'':'padding:15px;'">
						<div class="newstitle">
							{{newsdata.title}}
						</div>
						<div class="newsmsg2" :style="screenWidth>785?'':'padding:15px;'">
							<div class="date">
								{{newsdata.create_time}}
							</div>
							<div class="author">
								来源：{{newsdata.author||'网络'}}
							</div>
							<div class="">
								浏览数：{{newsdata.uv}}
							</div>
						</div>
						<div class="richbox" v-html="newsdata.content" >
							
						</div>
					</div>
				</div>
				<div class="newslist_rightbox" :style="screenWidth>785?'':'width:100%;'" >
					<div class="quicknewslist" v-if="screenWidth>785">
						<div class="quick_title">
							最新资讯
						</div>
						<div class="quicknews"   >
							<div class="quick_items"   v-for="(item, index) in quicklist" :key="item"  @click="detail(item.id,item.link)" @mouseenter="onitemopen(index)" >
								<i class="el-icon-question" v-if="index!=newsiconon" style="color: #ddd;"></i>
								<i class="el-icon-warning-outline" v-if="index==newsiconon" style="color: #1b9d57;font-size: 22px;"></i>
								<img :src="item.icon" v-if="index==newsiconon" alt="" srcset="">
								<div :class="index==newsiconon?'quick_text2':'quick_text'"   :style="index==newsiconon?'-webkit-box-orient:vertical;':''" >
									{{item.title}}
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="quicknewslist" :style="screenWidth>785?'':'width:calc(100% - 3px);'">
						<div class="quick_title">
							评论({{commenttotal}})
						</div>
						<div class="replybox"  v-if="screenWidth>785">
							<div class="reply_input">
								<el-input
								  type="textarea"
								  :autosize="{ minRows: 2, maxRows: 4}"
								  placeholder="请输入评论内容"
								  v-model="replytext">
								</el-input>
							</div>
							<div class="reply_buttonbox">
								
								 <el-button type="success" v-if="!token" @click="reply()">发表评论</el-button>
								 <el-popover
								   placement="top"
								 	v-model="showreplyvisible"
								    trigger="manual">
								   <div class="verify-box">
								   	<slide-verify
								   	  ref="replyRef"
								   	  :l="42"
								   	  :r="10"
								   	  :w="280"
								   	  :h="280"
								   	  :imgs="images"
								   	  slider-text="向右滑动"
								   	  @success="onreplySuccess"
								   	  @fail="onreplyFail"
								   	  @refresh="onreplyRefresh"
								   	  @fulfilled="onRefreshComplete"
								   	  @again="onreplyAgain"
								   	>
								   	</slide-verify>
								   </div>
								   <el-button type="success"  slot="reference" v-if="token" @click="showreplyvisible = true">发表评论</el-button>
								 </el-popover>
							</div>
						</div>
						<div class="commentlistbox">
							<div class="commentitem"   v-for="(item, index) in commentlist" :key="item" >
								<div class="comment_icon" v-if="item.user" >
									<img :src="item.user.avatarUrl" alt="" srcset="">
								</div>
								<div class="commentmainbox">
									<div class="commentmaintext">
										<span style="color:#409EFF;" >{{item.user.nickName+'：'}}</span>
										{{item.content}}
									</div>
									<div class="comment_msg"  >
										<div class="comment_time">
											{{item.create_time}}
										</div>
										<div class="replyreply"  v-if="replyreplyshow!=item.id&&screenWidth>785" @click="replyreplyshow = item.id;replyreplyshow2 = ''">
											回复
										</div>
										<div class="replyreply"  v-if="replyreplyshow==item.id&&screenWidth>785" @click="replyreplyshow = ''">
											收起
										</div>
									</div>
									<div class="replyreplybox" v-if="replyreplyshow==item.id">
										<div class="reply_input">
											<el-input
											  type="textarea"
											  :autosize="{ minRows: 2, maxRows: 4}"
											  placeholder="请输入回复内容"
											  v-model="replyreplytext">
											</el-input>
										</div>
										<div class="reply_buttonbox">
											 <el-button type="success" size="mini"  @click="replyreply(item.id,item.user.id)">发表回复</el-button>
										</div>
									</div>
									<div class="replysbox" v-if="item.replys.length>0">
										<div class="replys_item" v-for="(replys, index) in item.replys" :key="replys" >
											<div class="replys_text">
												<span style="color:#409EFF;" >{{replys.ruser.nickName}}</span>
												回复
												<span style="color:#409EFF;" >{{replys.cuser.nickName+':'}}</span>
												{{replys.content}}
											</div>
											<div class="comment_msg">
												<div class="">
													{{replys.create_time}}
												</div>
												<div class="replyreply"  v-if="replyreplyshow2!=replys.id&&screenWidth>785" @click="replyreplyshow2 = replys.id;replyreplyshow = ''">
													回复
												</div>
												<div class="replyreply"  v-if="replyreplyshow2==replys.id&&screenWidth>785" @click="replyreplyshow2 = ''">
													收起
												</div>
											</div>
											<div class="replyreplybox" v-if="replyreplyshow2==replys.id">
												<div class="reply_input">
													<el-input
													  type="textarea"
													  :autosize="{ minRows: 2, maxRows: 4}"
													  placeholder="请输入回复内容"
													  v-model="replyreplytext">
													</el-input>
												</div>
												<div class="reply_buttonbox">
													 <el-button type="success" size="mini"  @click="replyreply(replys.comment_id,replys.ruser.id)">发表回复</el-button>
												</div>
											</div>
										</div>
									</div>
									
								</div>
								
							</div>
						</div>
						<div class="comment_more">
							<el-pagination
							  background
							  :page-size="15"
							  :hide-on-single-page="true"
							  @current-change="commentpagechange"
							  layout="total, prev, pager, next"
							  :total="commenttotal">
							</el-pagination>
						</div>
					</div> -->
				</div>
				
			</div>
			
			
		</div>
		<!-- <div class="swim_box" v-if="screenWidth>785" >
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img :src="newsdata.sun_code" alt="" srcset="">
			</div>
		</div> -->
		<el-dialog
		  title="您还未登录,请登录后再操作"
		  :visible.sync="loginshow"
		  width="30%"
		  :before-close="onAgain"
		  center>
		  <el-form ref="form" :model="form" :rules="rules" label-width="100px">
			  <el-form-item label="手机端账号" prop="mobile">
			      <el-input v-model="form.mobile"></el-input>
			    </el-form-item>
				 <el-form-item label="密码" prop="password">
				    <el-input type="password" v-model="form.password" ></el-input>
				  </el-form-item>
			  <!-- <el-form-item > -->
				  <div class=""  @click="goregister()" style="color: #409EFF;width: 100%;text-align: right;">
				  	注册账号
				  </div>
			     
			   <!-- </el-form-item> -->
		  </el-form>
		  <span slot="footer"  class="dialog-footer" style="padding-top: 0px;">
		    <el-button @click="loginshow = false" style="margin-right: 15px;">取 消</el-button>
			<el-popover
			  placement="top"
				v-model="showvisible"
			   trigger="manual">
			  <div class="verify-box">
			  	<slide-verify
			  	  ref="slideRef"
			  	  :l="42"
			  	  :r="10"
			  	  :w="280"
			  	  :h="280"
			  	  :imgs="images"
			  	  slider-text="向右滑动"
			  	  @success="onSuccess"
			  	  @fail="onFail"
			  	  @refresh="onRefresh"
			  	  @fulfilled="onRefreshComplete"
			  	  @again="onAgain"
			  	>
			  	</slide-verify>
			  </div>
			  <el-button type="primary" slot="reference" @click="showvisible = true">登 录</el-button>
			</el-popover>
		    <!-- <el-button type="primary" @click="phonelogin()">登 录</el-button> -->
		  </span>
		</el-dialog>
		<div :class="tops?'navbar':'navbar-top'"  v-if="screenWidth>785">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		 <div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
	
	
</template>

<script>
	import {  getNewslist, getCategory, getPc,getnewscomment,phonelogin,checktoken,regettoken,newsSendcomment,newsSendreply,getbottomnav } from '@/request/api'
	
	export default {
	  name: "newslist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  //搜索相关
				top_search_url:'/Siteall',
				options: [
				{
					value: '/Siteall',
					label: '全站搜索'
				},{
				  value: '/Camplist',
				  label: '营地搜索'
				}, {
				  value: '/Baselist',
				  label: '基地搜索'
				}, {
				  value: '/Courselist',
				  label: '课程搜索'
				},{
				  value: '/Newslist',
				  label: '资讯搜索'
				},
				{
				  value: '/Activitylist',
				  label: '活动搜索'
				},
				{
				  value: '/Linelist',
				  label: '线路搜索'
				},
				{
				  value: '/traveler',
				  label: '机构搜索'
				},{
				  value: '/mentorlist',
				  label: '指导师搜索'
				},],
				//搜索相关
				manage_url:'',
				manageoptions:[
					{
					  value: 'http://qianjin.wanjiaxiao.cn/',
					  label: '研学报备'
					}, {
					  value: 'https://admin.henanyanxue.com/',
					  label: '管理入口'
					},
					
				],
				loginshow:false,
				activeIndex2: '/Newslist',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				form: {
					mobile: '',
					password: '',
					openid:'',
					unionid:'',
					is_pc:1,
				},
				rules: {
					mobile: [
						{ required: true, message: '请输入手机号码', trigger: 'blur' },
						{ min: 11, max: 11, message: '长度在11个数字', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请填写登录密码', trigger: 'blur' },
					],
					
				},
				replytext:'',
				replyreplytext:'',
				replyreplyshow:'',
				replyreplyshow2:'',
				logintype:true,
				banner:[
				],
				types:[],
				newslist:[],
				quicklist:[],
				commentlist:[],
				commenttotal:0,
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				comment_pageindex:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//滑块验证码
				images: [
					require('../../../static/img/滑块1.jpg'),
					require('../../../static/img/滑块2.jpg'),
					require('../../../static/img/滑块3.jpg')
				],
				tipsMsg:'',
				isSuccess: true,
				showvisible:false,
				//评论滑块
				showreplyvisible:false,
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					{
						link:'/traveler',
						text:'研学机构'
					},
					{
						link:'/mentorlist',
						text:'研学指导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
          {
            link: '/OrgRegister',
            text: '入驻平台'
          },
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		   this.getpcset()
	  },
	  mounted() {
		   const { id } = this.$route.query;
		   this.uuid = id
		     window.addEventListener('resize', this.handleResize, true)
		   var token = localStorage.getItem('token')||''
		   this.token=token
		   this.getDetails()
		this.getQuicklist()
		this.getnewscomment()
		 this.getbottomnav()
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
		// 销毁监听
		beforeDestroy() {
		  window.removeEventListener('resize', this.handleResize);
		},
	  methods: {
		  gotopsearch(){
		  		  this.$router.push({
		  		    path: this.top_search_url,
		  		    name: this.top_search_url,
		  		    query: {
		  		      stitle: this.stitle,
		  		    }
		  		  }); 
		  },
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		// this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  vanlinkgo(e){
		  		  console.log(e)
		  		  this.$router.push({
		  		    path: e.link,
		  		    name: e.link,
		  		    query: {
		  		    }
		  		  }); 
		  },
		  vannavmenushow(){
		  		this.vannavshow=false  
		  },
		  handleResize() {
		  		   this.top_bannerWidth = 0;
		    this.screenWidth = window.innerWidth;
		  		this.top_bannerWidth=window.innerWidth/3.42
		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
		    this.screenHeight = window.innerHeight;
		  },
		 //评论滑块
		 onreplySuccess(){
		 			  // this.isSuccess = true;
		 			  this.showreplyvisible=false
		 			  this.reply()
		 			  this.$refs.replyRef.reset();
		 },
		 onreplyFail(){
		 						  
		 },
		 onreplyRefresh(){
		 			  
		 },
		 onreplyAgain(){
		 			   this.$refs.replyRef.reset();
		 			   this.showreplyvisible=false
		 			  // this.loginshow=false
		 },
		  // 成功回调
		  onSuccess(){
			  this.tipsMsg = '恭喜您，验证成功啦！';
			  this.isSuccess = true;
					  this.showvisible=false
					  this.phonelogin()
					  this.$refs.slideRef.reset();
		  },
		  // 失败回调
		  onFail(){
			  this.tipsMsg = '验证失败，请重试哦！';
			  this.isSuccess = false;
		  },
		  // 点击刷新回调
		  onRefresh(){
			  this.tipsMsg = ''
		  },
		  // 刷新成功后回调
		  onRefreshComplete(){
					  this.tipsMsg = ''
					  this.isSuccess = true;
		  },
		  // 检测到非人为操作
		  onAgain() {
					  
					this.$refs.slideRef.reset();
					 this.showvisible=false
					this.loginshow=false
		  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  commentpagechange(val){
			this.comment_pageindex=val
			this.getnewscomment()
		  },
		  replyreply(id,uid){
			  var token = localStorage.getItem('token')||''
			  if(!token){
			  		this.gologin()
							  return
			  }
			  var data={
			  				  
			  }
			  checktoken(data).then(res=>{
				  if(res.data.code==201){
					  console.log(res)
					  regettoken(data).then(res=>{
						  localStorage.setItem('token', res.data.data.token)
						  localStorage.setItem('refreshToken', res.data.data.refreshToken)
					  })
				  }
				  // if(res)
			  })
			  data={
				  type:1,
				   content:this.replyreplytext,
				   comment_id:id,
				   uid:uid, 
			  }
			  if(!this.replyreplytext){
				  this.$alert('请填写评论内容', '评论内容未填写', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				  });
				  return
			  }
			  
			  newsSendreply(data).then(res=>{
				  if(res.data.code==200){
					  this.$alert(res.data.data, '回复成功', {
							confirmButtonText: '确认',
							callback: action => {
								this.replyreplyshow=''
								this.replyreplyshow2=''
								this.replyreplytext=''
								this.getnewscomment()
							}
					  });
					 
				  }
			  })
			  
		  },
		  gologin(){
		  			  this.$router.push({
		  			    path: "/Login",
		  			    name: "/Login",
		  				  query: {
		  				  }
		  			  });
		  },
		  reply(){
			   var token = localStorage.getItem('token')||''
			  if(!token){
				  this.gologin()
				  return
			  }
			  var data={
				  
			  }
			  checktoken(data).then(res=>{
				  if(res.data.code==201){
					  console.log(res)
					  regettoken(data).then(res=>{
						  localStorage.setItem('token', res.data.data.token)
						  localStorage.setItem('refreshToken', res.data.data.refreshToken)
					  })
				  }
				  // if(res)
			  })
			  data={
				type:1,
				type_id:this.uuid,
				content:this.replytext
			  }
			  if(!this.replytext){
				  this.$alert('请填写评论内容', '评论内容未填写', {
				  	confirmButtonText: '确认',
				  	callback: action => {
				  		
				  	}
				  });
				  return
			  }
			  newsSendcomment(data).then(res=>{
				  if(res.data.code==200){
					  this.replytext=''
					  this.getnewscomment()
				  }
			  })
		  },
		  phonelogin(){
			  var data=this.form
			  var that=this
			  if(this.form.mobile==''){
			  			this.$alert('请输入登录手机号', '请输入登录手机号', {
			  				confirmButtonText: '确认',
			  				callback: action => {
			  					
			  				}
			  			});
			    return;
			  }
			  if(this.form.mobile.length!=11){
			  			this.$alert('手机号长度位数错误', '手机号长度错误', {
			  				confirmButtonText: '确认',
			  				callback: action => {
			  					
			  				}
			  			});
			    return;
			  }
			  if( this.form.password==''){
			  			this.$alert('请填写密码', '存在未填项', {
			  				confirmButtonText: '确认',
			  				callback: action => {
			  					
			  				}
			  			});
			    return;
			  }
			  phonelogin(data).then(res=>{
				  if(res.data.data.flag==0){
					  this.$alert(res.data.data.msg, '账号不存在', {
					  	confirmButtonText: '确认',
					  	callback: action => {
					  		that.goregister()
					  	}
					  });
					  return
				  }
				  if(res.data.data.flag==2){
						  this.$alert(res.data.data.msg, '没有设置密码', {
							confirmButtonText: '确认',
							callback: action => {
								that.goreset()
							}
						  });
						  return
				  }
				  localStorage.setItem('token', res.data.data.token)
				  localStorage.setItem('refreshToken', res.data.data.refreshToken)
				  this.$router.go(0)
				  // this.$localStorage.set('token',res.data.data.token)
				  // this.$localStorage.set('refreshToken',res.data.data.refreshToken)
			  })
		  },
		  getnewscomment(){
			var data={
			      type:1,
			      type_id:this.uuid,
			      page_index:this.comment_pageindex,
			      page_size:15,
			    }  
				getnewscomment(data).then(res=>{
					
					this.commentlist=res.data.data.list
					this.commenttotal=res.data.data.total
					console.log(this.commentlist)
				})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  goreset(e){
			  this.$router.push({
			    path: "/reset",
			    name: "/reset",
			  		  query: {
			  		  }
			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
	  		  getpcset(){
	  		  		getPc().then(res=>{
	  		  			this.pcsetdata=res.data.data
	  		  		})  
	  		  },
		  getDetails(){
			var data={
				uuid:this.uuid
			}  
			getNewslist(data).then(res=>{
			  			  console.log(res.data)
						  this.newsdata=res.data.data
						  const loading = this.$loading({
						           lock: true,
						           text: 'Loading',
						           spinner: 'el-icon-loading',
						           background: 'rgba(0, 0, 0, 0.7)'
						         });
						  loading.close();
						  // this.quicklist=res.data.data.list
			  }).catch(error => {
				  console.error(error);
			});
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		getQuicklist(){
			var data={
				  page_index:1,
				  page_size:6,
			  }
			getNewslist(data).then(res=>{
			  			  console.log(res.data)
						  this.quicklist=res.data.data.list
			  }).catch(error => {
			  			  console.error(error);
			  			});
		},
		  _getNewslist(){
			  var data={
				  page_index:this.page_index,
				  page_size:10,
				  category_id:this.category_id,
			  }
			getNewslist(data).then(res=>{
			  			  console.log(res.data)
			  			  this.newslist=res.data.data.list
						  this.total=res.data.data.total
			  }).catch(error => {
			  			  console.error(error);
			  			});
		  },
		
		   handleSelect(key, keyPath) {
		          console.log(key, keyPath);
		        },
	    /*
	     * 查看详情
	     * */
	    detail(e,link) {
			if(link){
				window.location.href=link
			}else{
				this.uuid=e
			this.getDetails()
			this.getQuicklist()
			}
	      // this.$router.push({
	      //   path: "/NewsDetails",
	      //   name: "NewsDetails",
	      //   query: {
	      //     id: e
	      //   }
	      // });
	    },
	  }
	};
		
</script>

<style scoped>
	.replybox{
		padding: 20px;
		    border-bottom: 1px solid #ececec;
	}
	.reply_buttonbox{
		margin-top: 15px;
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.commentitem{
		padding: 20px;
		width: calc(100% - 40px);
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.replysbox{
		padding: 10px;
		background: #EBEEF5;
		border-radius: 5px;
		
	}
	.comment_more{
		padding: 10px;
	}
	.replys_item{
		
	}
	.replys_text{
		text-align: left;
		font-size: 15px;
		margin-bottom: 6px;
	}
	.replys_time{
		
	}
	.comment_icon{
		width: 40px;
		height: 40px;
		
	}
	.comment_icon img{
		width: 100%;
		height: 100%;
	}
	.commentmainbox{
		width: 280px;
		
	}
	.commentmaintext{
		font-size: 16px;
		text-align: left;
		color:#303133;
		margin-bottom: 10px;
	}
	
	
	.comment_msg{
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		margin-bottom: 10px;
		color:#909399 ;
	}
	.richbox{
		text-align: left;
		font-size: 16px;
	}
	.main_box{
		width: 1100px;
		min-height: 600px;
		margin: 0 auto;
	}
	.video_box{
		padding: 30px;
	}
	.video_box video{
		width: 100%;
	}
	.newsdatas{
		padding: 30px;
	}
	.newslist_box{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.newslist{
		width: 790px;
		background: #fff;
		margin: 20px;
		margin-left: 0px;
	}
	.newsitem{
		width:720px ;
		margin: 0px  10px;
		padding: 20px 0px;
		border-bottom: 1px dashed #dadada;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.newsimg{
		width: 280px;
		height: 180px;
		margin-right:20px ;
	}
	.newsimg img{
		width: 100%;
		height: 100%;
	}
	.newsmsg2{
		margin-top: 34px;
		    padding-bottom: 6px;
		    color: #999;
		    font-size: 14px;
		    height: 22px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			 border-bottom: 1px dashed #999;

	}
	::v-deep img{
	     max-width:100%;
	 }
	.newstitle{
		color: #333;
		/* color:red; */
	    font-weight: 400;
	    font-size: 24px;
	    text-align: center;
		-webkit-line-clamp: 3;
	}
	.date{
		margin-right: 30px;
	}
	.newsmsg2 .author{
		display: inline-block;
		max-width: 320px;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: text-bottom;
		white-space: nowrap;
	}
	
	.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
		color: #1b9d57;
	}
	.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
		color: #1b9d57;
	}
	.el-tabs__item{
		font-size: 18px;
		height: 60px;
		line-height: 60px;
		/* padding:30px ; */
	}
	.el-tabs--border-card .el-tabs__header{
		background-color: #ffffff;
	}
	.news_bottom{
		    font-size: 14px;
		    color: #999;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.pages_total{
		padding: 20px;
		padding-bottom: 0px;
		
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #1b9d57;
	}
	
	/* 快速资讯内容 */
	.quicknewslist{
		width: 395px;
		background-color: #ffffff;
		margin-top: 20px;
		border: 1px solid #DCDFE6;
		box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
	}
	.newslist_rightbox{
		width: 395px;
		
	}
	.quick_title{
		    padding: 20px  0px;
		    background: #fff;
		    border-bottom: 2px solid #f8f8f8;
			font-size: 20px;
			color: #333;
			font-weight: 400;
	}
	.quicknews{
		padding: 20px;
	}
	.quick_items{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 20px 0px;
		
	}
	.quick_items i{
		margin-right: 10px;
	}
	.quick_items img{
		width: 120px;
		height: 77px;
		/* margin-left: 10px; */
		margin-right: 10px;
		background-color: #333;
	}
	.quick_text{
		    /* width: 100%; */
		color: #333;
		    font-size: 16px;
		    font-weight: 400;
		    line-height: 2;
		    overflow: hidden;
		    text-overflow: ellipsis;
		    white-space: nowrap;
			text-align: left;
	}
	.quick_text2{
		/* color: #333; */
		width: 180px;
		font-size: 16px;
		font-weight: 400;
		color: #1b9d57;
		white-space: normal;
		/* line-height: 2; */
/* 		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap; */
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		display: -webkit-box;
		-webkit-line-clamp:2;
		-webkit-box-orient:vertical;
		overflow: hidden;

	}
</style>